import { render, staticRenderFns } from "./InformationPageEditor.vue?vue&type=template&id=4f44d890&scoped=true&"
import script from "./InformationPageEditor.vue?vue&type=script&lang=js&"
export * from "./InformationPageEditor.vue?vue&type=script&lang=js&"
import style0 from "./InformationPageEditor.vue?vue&type=style&index=0&id=4f44d890&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f44d890",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VIcon,VProgressLinear})
